import styled from 'styled-components'
import PropTypes from 'prop-types'

import { container } from '@h2/components/mixins'

import { Top, gridArea as top } from './top'
import { Content, gridArea as cnt } from './content'
import { Sidebar, gridArea as sdb } from './sidebar'
import { Bottom, gridArea as btm } from './bottom'
import { Columns, gridArea as col } from './columns'
import { gap as defaultGap } from './defaults'
import { getAppliedSlots } from './getAppliedSlots'

const slotName = slot => slot.slotName
const layouts = new Map([
  [
    [Top, Content, Columns, Sidebar, Bottom].map(slotName).toString(),
    `
  "${top} ${top} ${top} ${top} ${top} ${top} ${top} ${top} ${top} ${top} ${top} ${top}"
  "${cnt} ${cnt} ${cnt} ${cnt} ${cnt} ${cnt} ${cnt} ${cnt} ${cnt} ${sdb} ${sdb} ${sdb}"
  "${col} ${col} ${col} ${col} ${col} ${col} ${col} ${col} ${col} ${sdb} ${sdb} ${sdb}"
  "${btm} ${btm} ${btm} ${btm} ${btm} ${btm} ${btm} ${btm} ${btm} ${btm} ${btm} ${btm}"
  `
  ],
  [
    [Top, Columns, Content, Sidebar, Bottom].map(slotName).toString(),
    `
  "${top} ${top} ${top} ${top} ${top} ${top} ${top} ${top} ${top} ${top} ${top} ${top}"
  "${col} ${col} ${col} ${col} ${col} ${col} ${col} ${col} ${col} ${sdb} ${sdb} ${sdb}"
  "${cnt} ${cnt} ${cnt} ${cnt} ${cnt} ${cnt} ${cnt} ${cnt} ${cnt} ${sdb} ${sdb} ${sdb}"
  "${btm} ${btm} ${btm} ${btm} ${btm} ${btm} ${btm} ${btm} ${btm} ${btm} ${btm} ${btm}"
  `
  ],
  [
    [Top, Content, Sidebar, Bottom].map(slotName).toString(),
    `
  "${top} ${top} ${top} ${top} ${top} ${top} ${top} ${top} ${top} ${top} ${top} ${top}"
  "${cnt} ${cnt} ${cnt} ${cnt} ${cnt} ${cnt} ${cnt} ${cnt} ${cnt} ${sdb} ${sdb} ${sdb}"
  "${btm} ${btm} ${btm} ${btm} ${btm} ${btm} ${btm} ${btm} ${btm} ${btm} ${btm} ${btm}"
  `
  ],
  [
    [Top, Sidebar, Content, Bottom].map(slotName).toString(),
    `
  "${top} ${top} ${top} ${top} ${top} ${top} ${top} ${top} ${top} ${top} ${top} ${top}"
  "${sdb} ${sdb} ${sdb} ${cnt} ${cnt} ${cnt} ${cnt} ${cnt} ${cnt} ${cnt} ${cnt} ${cnt}"
  "${btm} ${btm} ${btm} ${btm} ${btm} ${btm} ${btm} ${btm} ${btm} ${btm} ${btm} ${btm}"
  `
  ],
  [
    [Top, Content, Sidebar].map(slotName).toString(),
    `
  "${top} ${top} ${top} ${top} ${top} ${top} ${top} ${top} ${top} ${top} ${top} ${top}"
  "${cnt} ${cnt} ${cnt} ${cnt} ${cnt} ${cnt} ${cnt} ${cnt} ${cnt} ${sdb} ${sdb} ${sdb}"
  `
  ],
  [
    [Content, Sidebar, Bottom].map(slotName).toString(),
    `
  "${cnt} ${cnt} ${cnt} ${cnt} ${cnt} ${cnt} ${cnt} ${cnt} ${cnt} ${sdb} ${sdb} ${sdb}"
  "${btm} ${btm} ${btm} ${btm} ${btm} ${btm} ${btm} ${btm} ${btm} ${btm} ${btm} ${btm}"
  `
  ],
  [
    [Sidebar, Content, Columns].map(slotName).toString(),
    `
  "${sdb} ${sdb} ${sdb} ${cnt} ${cnt} ${cnt} ${cnt} ${cnt} ${cnt} ${cnt} ${cnt} ${cnt}"
  "${col} ${col} ${col} ${col} ${col} ${col} ${col} ${col} ${col} ${col} ${col} ${col}"
  `
  ],
  [
    [Columns, Content, Sidebar].map(slotName).toString(),
    `
  "${col} ${col} ${col} ${col} ${col} ${col} ${col} ${col} ${col} ${col} ${col} ${col}"
  "${cnt} ${cnt} ${cnt} ${cnt} ${cnt} ${cnt} ${cnt} ${cnt} ${cnt} ${sdb} ${sdb} ${sdb}"
  `
  ],
  [
    [Top, Content].map(slotName).toString(),
    `
  "${top} ${top} ${top} ${top} ${top} ${top} ${top} ${top} ${top} ${top} ${top} ${top}"
  "${cnt} ${cnt} ${cnt} ${cnt} ${cnt} ${cnt} ${cnt} ${cnt} ${cnt} ${cnt} ${cnt} ${cnt}"
  `
  ],
  [
    [Content, Bottom].map(slotName).toString(),
    `
    "${cnt} ${cnt} ${cnt} ${cnt} ${cnt} ${cnt} ${cnt} ${cnt} ${cnt} ${cnt} ${cnt} ${cnt}"
    "${btm} ${btm} ${btm} ${btm} ${btm} ${btm} ${btm} ${btm} ${btm} ${btm} ${btm} ${btm}"
  `
  ],
  [
    [Content, Sidebar].map(slotName).toString(),
    `
  "${cnt} ${cnt} ${cnt} ${cnt} ${cnt} ${cnt} ${cnt} ${cnt} ${cnt} ${sdb} ${sdb} ${sdb}"
  `
  ],
  [
    [Sidebar, Content].map(slotName).toString(),
    `
  "${sdb} ${sdb} ${sdb} ${cnt} ${cnt} ${cnt} ${cnt} ${cnt} ${cnt} ${cnt} ${cnt} ${cnt}"
  `
  ],
  [
    [Content, Columns].map(slotName).toString(),
    `
  "${cnt} ${cnt} ${cnt} ${cnt} ${cnt} ${cnt} ${cnt} ${cnt} ${cnt} ${cnt} ${cnt} ${cnt}"
  "${col} ${col} ${col} ${col} ${col} ${col} ${col} ${col} ${col} ${col} ${col} ${col}"
  `
  ],
  [
    [Columns, Content].map(slotName).toString(),
    `
  "${col} ${col} ${col} ${col} ${col} ${col} ${col} ${col} ${col} ${col} ${col} ${col}"
  "${cnt} ${cnt} ${cnt} ${cnt} ${cnt} ${cnt} ${cnt} ${cnt} ${cnt} ${cnt} ${cnt} ${cnt}"
  `
  ],
  [
    [Columns].map(slotName).toString(),
    `
  "${col} ${col} ${col} ${col} ${col} ${col} ${col} ${col} ${col} ${col} ${col} ${col}"
  `
  ],
  [
    [Content].map(slotName).toString(),
    `
  "${cnt} ${cnt} ${cnt} ${cnt} ${cnt} ${cnt} ${cnt} ${cnt} ${cnt} ${cnt} ${cnt} ${cnt}"
  `
  ]
])
const getTemplateAreas = ({ applied }) => {
  const uniq = [...new Set(applied)]

  return (
    layouts.get(uniq.toString()) ??
    `"${cnt} ${cnt} ${cnt} ${cnt} ${cnt} ${cnt} ${cnt} ${cnt} ${cnt} ${cnt} ${cnt} ${cnt}"`
  )
}
const Main = styled.main`
  grid-area: layout;
  display: grid;
  width: 100%;
  grid-template-columns: repeat(12, 1fr);
  grid-auto-rows: auto;
  grid-template-areas: ${getTemplateAreas};
  gap: ${({ gap }) => gap};
  ${({ isContainer }) => (isContainer ? container : null)};
`
const Layout = ({ children, gap = defaultGap, isContainer = true, ...rest }) => (
  <Main gap={gap} isContainer={isContainer} applied={getAppliedSlots(children)} {...rest}>
    {children}
  </Main>
)

Layout.propTypes = {
  /** The row and/or column gap between different layout children */
  gap: PropTypes.string,
  /** Whether the layout should be a responsive container constraining the overall width while centering */
  isContainer: PropTypes.bool,
  children: props => {
    const appliedSlots = getAppliedSlots(props.children).toString()

    if (!layouts.has(appliedSlots)) {
      return new Error(
        `Invalid \`children\` applied to Page.Layout. Template area not defined:\n${appliedSlots}`
      )
    }
  }
}
Layout.slotName = 'PageLayout'
Layout.area = 'layout'

export { Layout }
